export const SET_PARK_FEE = 'SET_PARK_FEE';
export const SET_PORT_FEE = 'SET_PORT_FEE';
export const SET_TAX = 'SET_TAX';
export const SET_TOTALS = 'SET_TOTALS';
export const SET_TOTALS_EXTRAS = 'SET_TOTALS_EXTRAS';